import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "grad",
    gradientTransform: "rotate(90)"
  }, [
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "0%",
      "stop-color": "#008080",
      "stop-opacity": "1"
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "100%",
      "stop-color": "white",
      "stop-opacity": "0.4"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Area = _resolveComponent("Area")!
  const _component_Line = _resolveComponent("Line")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createBlock(_component_Chart, {
    size: { width: 460, height: 120 },
    data: _ctx.series,
    margin: _ctx.margin,
    direction: _ctx.direction,
    axis: _ctx.axis
  }, {
    layers: _withCtx(() => [
      _createVNode(_component_Area, {
        dataKeys: ['date', 'count'],
        type: "natural",
        areaStyle: { fill: 'url(#grad)' }
      }, null, 8, ["areaStyle"]),
      _createVNode(_component_Line, {
        dataKeys: ['date', 'count'],
        type: "natural",
        lineStyle: {
          stroke: '#008080',
          strokeWidth: 1,
        },
        dotStyle: {
          hide: true,
          strokeWidth: 1,
        },
        hideDot: true
      }),
      _hoisted_1
    ]),
    widgets: _withCtx(() => [
      _createVNode(_component_Tooltip, {
        borderColor: "#008080",
        config: {
          date: { color: '#008080', label: 'Date' },
          count: { color: '#008080', label: 'Bookings' },
        }
      })
    ]),
    _: 1
  }, 8, ["data", "margin", "direction", "axis"]))
}